<template>
  <div id="charts5">
    <div class="item" v-for="(item, index) in keywords" :key="index" :style="position[index]">
      <SvgIcon v-if="[0, 3, 6, 9, 12, 15, 18].includes(index)" icon-class="iconqipao-zi"></SvgIcon>
      <SvgIcon v-else-if="[1, 4, 7, 10, 13, 16, 19].includes(index)" icon-class="iconqipao-lv"></SvgIcon>
      <SvgIcon v-else-if="[2, 5, 8, 11, 14, 17, 20].includes(index)" icon-class="iconqipao-lan"></SvgIcon>
      <div>{{item}}</div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {
      keywords: ['细心认真', '积极主动', '细心认真', '积极主动', '积极主动'],
      positionData: [],
      position: []
    }
  },
  mounted() {
    this.allPosition()
  },
  methods: {
    allPosition() {
      const xCount = parseInt(document.querySelector('#charts5').clientWidth / document.querySelector('.item').clientWidth)
      const yCount = parseInt(document.querySelector('#charts5').clientHeight / document.querySelector('.item').clientHeight) - 4
      const scale = 750 / document.querySelector('body').clientWidth
      const itemWidth = 150 / scale
      const itemHeight = 56 / scale
      this.positionData = [
        {
          top: itemHeight * 0,
          left: itemWidth * 0
        },
        {
          top: itemHeight * 1.2,
          left: itemWidth * 0.2
        },
        {
          top: itemHeight * 2.4,
          left: itemWidth * 0.5
        },
        {
          top: itemHeight * 3.4,
          left: itemWidth * 0.3
        },
        {
          top: itemHeight * 0.3,
          left: itemWidth * 1.2
        },
        {
          top: itemHeight * 1.5,
          left: itemWidth * 1.5
        },
        {
          top: itemHeight * 2.6,
          left: itemWidth * 1.6
        },
        {
          top: itemHeight * 0.2,
          left: itemWidth * 2.2
        },
        {
          top: itemHeight * 1.4,
          left: itemWidth * 2.5
        },
        {
          top: itemHeight * 2.8,
          left: itemWidth * 2.6
        },
        {
          top: itemHeight * 0,
          left: itemWidth * 3.2
        },
        {
          top: itemHeight * 3.6,
          left: itemWidth * 3.2
        }
      ]
      // for(let i = 0; i < xCount; i++) {
      //   for(let j = 0; j < yCount; j++) {
      //     this.positionData.push({
      //       top: itemHeight * j, //3
      //       left: itemWidth * i  //4
      //     })
      //   }
      // }
      let position = this.getRandomArrayElements(this.positionData, this.keywords.length)
      position.forEach(item => {
        this.position.push(`top: ${item.top}px; left: ${item.left}px;`)
      })
    },
    // 取多个随机元素
    getRandomArrayElements(arr, count) {
      var shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    }
  }
};
</script>
<style lang="scss" scoped>
#charts5 {
  width: 100%;
  height: 350px;
  background: url('../../../assets/guanjianci.png') bottom center no-repeat;
  background-size: 320px 158px;
  position: relative;
  .item {
    position: absolute;
    &:nth-of-type(3n+1) {
      div {
        color: #8471FF;
      }
    }
    &:nth-of-type(3n+2) {
      div {
        color: #03B187;
      }
    }
    &:nth-of-type(3n) {
      div {
        color: #37A0FF;
      }
    }
    svg {
      width:140px;
      height:46px;
    }
    div {
      font-size:20px;
      position: absolute;
      top: 50%;
      left: 20%;
      transform: translateY(-70%)
    }
  }
}
</style>